/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RuntimeEvent,
    RuntimeEventFromJSON,
    RuntimeEventFromJSONTyped,
    RuntimeEventToJSON,
} from './';

/**
 * A list of runtime events.
 * @export
 * @interface RuntimeEventListAllOf
 */
export interface RuntimeEventListAllOf {
    /**
     * 
     * @type {Array<RuntimeEvent>}
     * @memberof RuntimeEventListAllOf
     */
    events: Array<RuntimeEvent>;
}

export function RuntimeEventListAllOfFromJSON(json: any): RuntimeEventListAllOf {
    return RuntimeEventListAllOfFromJSONTyped(json, false);
}

export function RuntimeEventListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): RuntimeEventListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'events': ((json['events'] as Array<any>).map(RuntimeEventFromJSON)),
    };
}

export function RuntimeEventListAllOfToJSON(value?: RuntimeEventListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'events': ((value.events as Array<any>).map(RuntimeEventToJSON)),
    };
}


